"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  default: '%s 校验失败',
  required: '%s 是必填字段',
  format: {
    number: '%s 不是合法的数字',
    email: '%s 不是合法的 email 地址',
    url: '%s 不是合法的 URL 地址',
    tel: '%s 不是合法的电话号码'
  },
  number: {
    length: '%s 长度必须是 %s',
    min: '%s 字段数值不得小于 %s',
    max: '%s 字段数值不得大于 %s',
    minLength: '%s 字段字符长度不得少于 %s',
    maxLength: '%s 字段字符长度不得超过 %s'
  },
  string: {
    length: '%s 长度必须是 %s',
    min: '%s 字段数值不得小于 %s',
    max: '%s 字段数值不得大于 %s',
    minLength: '%s 字段字符长度不得少于 %s',
    maxLength: '%s 字段字符长度不得超过 %s'
  },
  array: {
    length: '%s 个数必须是 %s',
    minLength: '%s 个数不得少于 %s',
    maxLength: '%s 个数不得超过 %s'
  },
  pattern: '%s 字段数值 %s 不匹配正则 %s'
};
exports.default = _default;